import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import colors, { shadows } from '../theme';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a short delay
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: colors.white,
      borderTop: `2px solid ${colors.landing.coral}`,
      boxShadow: shadows.lg,
      padding: '24px',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '24px',
      flexWrap: 'wrap',
    }}>
      {/* Text Content */}
      <div style={{
        flex: '1',
        minWidth: '300px',
      }}>
        <h3 style={{
          fontSize: '18px',
          fontWeight: 700,
          marginBottom: '8px',
          color: colors.gray[900],
        }}>
          🍪 We use cookies
        </h3>
        <p style={{
          fontSize: '14px',
          lineHeight: 1.6,
          color: colors.gray[700],
          margin: 0,
        }}>
          We use essential cookies for authentication and analytics cookies to improve our service.
          {' '}
          <button
            onClick={() => {
              setIsVisible(false);
              navigate('/privacy');
            }}
            style={{
              background: 'none',
              border: 'none',
              color: colors.landing.coral,
              textDecoration: 'underline',
              cursor: 'pointer',
              padding: 0,
              fontSize: '14px',
              fontWeight: 600,
            }}
          >
            Learn more in our Privacy Policy
          </button>
        </p>
      </div>

      {/* Buttons */}
      <div style={{
        display: 'flex',
        gap: '12px',
        flexShrink: 0,
      }}>
        <button
          onClick={handleDecline}
          style={{
            padding: '12px 24px',
            backgroundColor: 'transparent',
            border: `2px solid ${colors.gray[300]}`,
            borderRadius: '8px',
            color: colors.gray[700],
            fontSize: '14px',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.2s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = colors.gray[100];
            e.currentTarget.style.borderColor = colors.gray[400];
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.borderColor = colors.gray[300];
          }}
        >
          Decline
        </button>
        <button
          onClick={handleAccept}
          style={{
            padding: '12px 24px',
            background: colors.gradients.coral,
            border: 'none',
            borderRadius: '8px',
            color: colors.white,
            fontSize: '14px',
            fontWeight: 700,
            cursor: 'pointer',
            boxShadow: shadows.md,
            transition: 'all 0.2s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = shadows.lg;
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = shadows.md;
          }}
        >
          Accept All Cookies
        </button>
      </div>
    </div>
  );
}
